import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CustomerSupportService} from '../../customer-support.service';

@Component({
    selector: 'app-contact-dialog',
    templateUrl: './contact-dialog.component.html',
    styleUrls: ['./contact-dialog.component.scss'],
    styles: [`
        .dialog-container li {
            font-size: 18px;
        }
    `]
})
export class ContactDialogComponent{
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private csService: CustomerSupportService) {}

    changeStatus(event, contactFormId) {
        this.csService.changeContactFormStatus(contactFormId, event.target.value).subscribe(res => {
        })
    }

}
